/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

const mediaAndText = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 17h7V6H4v11zm9-10v1.5h7V7h-7zm0 5.5h7V11h-7v1.5zm0 4h7V15h-7v1.5z" />
	</SVG>
);

export default mediaAndText;
